import "./sidebar.css";
import { Link, useLocation } from "react-router-dom";
import classNames from 'classnames';
import {useDispatch, useSelector} from 'react-redux'

export default function Sidebar() {

  const location = useLocation()

  const apiResponse = useSelector(state=>{
    const {membership} = state
    const {application} = membership
    return{
        application
    }
  })

  const {pathname}  = location

  const pathName= pathname.split('/')
  const finalPathName = pathName[1]


  return (
    <div className={classNames("sidebar",{'disabled-side-bar': finalPathName === 'applicant'})} style={{display: finalPathName === 'member' || finalPathName === 'applicant' ? 'none': ''}}>
      <div className="sidebarWrapper">
        <div className="sidebarMenu">
          <ul className="sidebarList">
            <Link to="/dashboard" exact className="side-bar-link">
                <div className={classNames("side-bar-link",{'side-bar-background': finalPathName === 'dashboard'})}>
                    <li className={classNames("",{'active-sidebar-link': finalPathName === 'dashboard'})}>
                      <span>
                        Dashboard
                      </span>
                    </li>
                </div>
            </Link>
            <Link to="/application" exact className="side-bar-link">
                <div className={classNames("side-bar-link",{'side-bar-background': finalPathName === 'application'})}>
                    <li className={classNames("",{'active-sidebar-link': finalPathName === 'application'})}>
                      <span>
                          My application
                      </span>
                    </li>
                  </div>
            </Link>
         { apiResponse.application &&  <Link to="/membership" className="side-bar-link">
              <div className={classNames("side-bar-link",{'side-bar-background': finalPathName === 'membership'})}>
                  <li className={classNames("",{'active-sidebar-link': finalPathName === 'membership'})}>
                    <span>
                    Membership
                    </span>
                  </li>
              </div>
            </Link>}
            <Link to="/payments" className="side-bar-link">
               <div className={classNames("side-bar-link",{'side-bar-background': finalPathName === 'payments'})}>
                  <li className={classNames("",{'active-sidebar-link': finalPathName === 'payments'})}>
                    <span>
                    Payments
                    </span>
                  </li>
              </div>
            </Link>
            <Link to="/billers" className="side-bar-link">
              <div className={classNames("side-bar-link",{'side-bar-background': finalPathName === 'billers'})}>
                  <li className={classNames("",{'active-sidebar-link': finalPathName === 'billers'})}>
                    <span>
                      Bills
                    </span>
                  </li>
              </div>
            </Link>
            {/* <Link to="/calender" className="link">
              <li className={classNames("sidebarListItem",{'active-sidebar-link': finalPathName === 'calender'})}>
                <span>
                    Calendar
                </span>
              </li>
            </Link> */}
            {/* <Link to="/profile" className="link">
              <li className={classNames("sidebarListItem",{'active-sidebar-link': finalPathName === 'profile'})}>
                <span>
                    My profile
                </span>
              </li>
            </Link> */}
          </ul>
          {/* <Link to="/" className="link">
              <li className={classNames("sidebarListItem",{'active-sidebar-link': finalPathName === 'profile'})}>
                <span style={{color: 'red'}}>
                    Logout (Test)
                </span>
              </li>
            </Link> */}
        </div>
      </div>
    </div>
  );
}
